import { Text } from "@chakra-ui/react";
import { Box, Flex } from "@chakra-ui/layout";
import colors from "core/resources/theme/colors";
import { IoClose } from "react-icons/io5";
import OutlineButton from "../Button/OutlineButton";

interface SelectMultipleOptionDisplayProps {
  options: {
    label: string;
    id: any;
  }[];
  onRemove: (id: any) => any;
  onRemoveAll: () => any;
  borderBottom?: boolean;
  clearButton?: boolean;
  clearButtonPosition?: "top" | "bottom";
}
function SelectMultipleOptionDisplay({
  options,
  onRemove,
  onRemoveAll,
  borderBottom = true,
  clearButton = true,
  clearButtonPosition = "bottom",
}: SelectMultipleOptionDisplayProps) {
  return (
    <Flex
      gridGap="12px"
      w="100%"
      borderBottomWidth={borderBottom ? 1 : undefined}
      borderBottomColor={colors.borderGray}
      mb="4px"
      pb="8px"
    >
      <Flex w={clearButton ? "85%" : "100%"} gridGap="6px" flexWrap="wrap">
        {options.map((o) => (
          <Flex
            borderWidth={1}
            borderColor={colors.primary}
            rounded="full"
            h="30px"
            px="10px"
            alignItems="center"
            key={o.id}
            bg={colors.white}
          >
            <Text fontSize="12px" fontWeight="500" color={colors.black700}>
              {o.label}
            </Text>
            <Box
              ml="4px"
              pl={"4px"}
              borderLeftWidth={1}
              borderLeftColor={colors.borderGray}
            >
              <IoClose
                size={14}
                color={colors.black700}
                cursor="pointer"
                onClick={() => onRemove(o.id)}
              />
            </Box>
          </Flex>
        ))}
      </Flex>
      {clearButton ? (
        <OutlineButton
          size="sm"
          onClick={onRemoveAll}
          ml="auto"
          mt={clearButtonPosition === "bottom" ? "auto" : 0}
        >
          Limpar
        </OutlineButton>
      ) : null}
    </Flex>
  );
}

export default SelectMultipleOptionDisplay;
